import React, { useContext } from "react";
import { useEffect, useState } from "react";
import CustomerApi from "../../../../../API/CustomerApi";
import Swal from "sweetalert2";
import Tooltip from "@mui/material/Tooltip";
import { FaEdit } from "react-icons/fa";
import StringIntReq from "../../../../../Requests/StringIntReq";
import { MdOutlineDelete } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";
import { IoSaveOutline } from "react-icons/io5";
import convertUTCToCST from "../../../../../Services/DateFormatter";
import { UserContext } from "../../../../../App";
const Notes = ({ lead, disabled , reload }) => {
  const [note, setNote] = useState("📝 ");
  const [notes, setNotes] = useState([]);
  const [isViewNotesOpen, setIsViewNotesOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [noteData, setNoteData] = useState({
    note: null,
    id: null,
  });
  const user = useContext(UserContext)

  const handleQuickNoteClick = async (item) => {
    // console.log("note:",item);

    let req = {
      Note: item,
      LeadId: lead.id,
      CreatorId: user.id,
    };

    const res = await CustomerApi.CreateQuickNote(req);

    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Quick Note Added",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      GetQuickNotes();
      setIsViewNotesOpen(!isViewNotesOpen);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  useEffect(() => {
    console.log("notes", notes);
  }, [notes]);

  const GetQuickNotes = async () => {
    setIsViewNotesOpen(false);
    let req = {
      LeadId: lead?.id,
    };
    const res = await CustomerApi.GetQuickNotes(req);
    if (res?.status?.success) {
      setNotes(res.data);
    if (res.data.length > 0) {
        setIsViewNotesOpen(true);
      }
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const handleEditNoteClick = async (item) => {
    // console.log("note:",item);
    let req = {
      id: item.id,
      note: item.note,
    };
    const res = await CustomerApi.EditQuickNote(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Quick Note Added",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
      setNoteData({
        note: null,
        id: null,
      });
      GetQuickNotes();
      
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  const DeleteQuickNote = async (id) => {
    let req = new StringIntReq();
    req.int = id;
    const res = await CustomerApi.DeleteQuickNote(req);
    if (res?.status?.success) {
      Swal.fire({
        icon: "success",
        title: "Success",
        text: "Quick Note Deleted",
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
     
      GetQuickNotes();
      setIsViewNotesOpen(!isViewNotesOpen);
    } else {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: res?.status?.message,
        allowOutsideClick: false,
        allowEscapeKey: false,
        allowEnterKey: false,
        showConfirmButton: true,
        toast: true,
        timer: 1500,
        position: "bottom-end",
        didOpen: () => {
          Swal.hideLoading();
        },
      });
    }
  };

  useEffect(() => {

    GetQuickNotes();
  }, [lead, reload]);

  return (
    <div className="  flex flex-col items-center w-full">
      <div className=" p-2 rounded-lg  w-full">
        <div className="flex justify-between items-center ">
          <h3 className="font-bold text-gray-700">Notes</h3>
          <div className="flex items-center justify-between gap-1 relative">
            <button
              onClick={() => {
                if (disabled) {
                  return;
                }
                setIsViewNotesOpen(!isViewNotesOpen);
              }}
              className="bg-blue-600 text-white rounded-lg text-sm  px-4 py-2 "
            >
              {isViewNotesOpen ? "Add New Note" : "View Notes"}
            </button>
          </div>
        </div>

        {isViewNotesOpen && (
          <div
            //  {...QuickNotehandlers}
            className="relative mt-2 w-full rounded-lg  text-gray-600  h-52 overflow-y-auto space-y-2"
            // style={{ scrollbarWidth: "none" }}
          >
            {notes?.map((note, index) => (
              <div key={note.id || index} className="overflow-hidden whitespace-pre-wrap flex flex-col gap-2 justify-between items-start p-2 border border-gray-200 rounded-lg bg-gray-50">
                { noteData.id !== note.id && (
                  <Tooltip
                    key={index}
                    title={`${convertUTCToCST(
                      note.timestamp
                    )} | ${note.note}`}
                  >
                    <div className="   rounded-lg flex items-center">
                      {note.note}
                    </div>
                  </Tooltip>
                )}
                {isEditing && noteData.id === note.id && 
                (
                  <div className="flex bg-[#fff] p-1  border border-gray-200 rounded-lg items-end justify-between w-full">
                    <textarea
                      value={noteData.note} // Ensure the correct state is used
                      onChange={(e) => {
                        setNoteData({
                          ...noteData,
                          note: e.target.value, // Update the note property correctly
                        });
                      }}
                      className="w-full h-full rounded-lg p-1 resize-none focus:outline-none"
                      placeholder="Type your notes here..."
                    ></textarea>
                    <button
                      onClick={() => {
                        if (disabled) {
                          return;
                        }
                        handleEditNoteClick(noteData);
                        setIsEditing(false);
                      }}
                      className="bg-blue-600 text-white rounded-md text-xs  px-2 py-1"
                    >
                      Save
                    </button>
                  </div>
                )}

                {
                  noteData.id !== note.id &&
                  <div className=" overflow-hidden text-sm whitespace-nowrap rounded-lg flex items-center justify-between w-full">
                  {convertUTCToCST(note.timestamp)}<br/>
                  {
                    note.creator ?
                    (note.creator?.firstName + " " + note.creator?.lastName) : ""
                  }

                  <div className="flex gap-2 ml-auto">
                    <Tooltip title="Edit Note">
                      <button
                        onClick={() => {
                          if (disabled) {
                            return;
                          }
                          setIsEditing(true);
                          setNoteData({
                            ...noteData,
                            note: note.note,
                            id: note.id,
                          });


                        }}
                        className="text-green-500"
                      >
                        <FaRegEdit className="text-green-500" />
                      </button>
                    </Tooltip>
                    <Tooltip title="Delete Note">
                      <button
                      onClick={() => {
                        DeleteQuickNote(note.id);
                      }}
                      >
                        <MdOutlineDelete className="text-red-500" />
                      </button>
                    </Tooltip>
                  </div>
                </div>}
              </div>
            ))}
          </div>
        )}

        {!isViewNotesOpen && (
          <div className="mt-2 w-full relative rounded-lg p-2 border-gray-200 h-40 ">
            <textarea
              value={note}
              onChange={(e) => {
                // Ensure the icon stays at the start
                if (!e.target.value.startsWith("📝 ")) {
                  setNote("📝 " + e.target.value.replace(/^📝\s*/, ""));
                } else {
                  setNote(e.target.value);
                }
              }}
              className="w-full h-full border border-gray-200 rounded-lg p-2 resize-none focus:outline-none"
              placeholder="Type your notes here..."
            ></textarea>

            <button
              onClick={() => {
                if (disabled) {
                  return;
                }
                handleQuickNoteClick(note);
                setNote("");
                // setIsQuickNotesOpen(true);
              }}
              className="bg-blue-600 text-white rounded-lg text-sm  
                                                 absolute bottom-2 right-2 px-4 py-2 "
            >
              Save
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Notes;
